import { useDispatch, useSelector } from 'react-redux';
import { visualizationSelector } from '../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useUploadImage } from '../../../hooks/useUploadImage';
import { uploadVisualization } from '../../../../../store/slices/dashboardSlice/action';

export const useModalVisualizationBody = () => {
    const dispatch = useDispatch();
    const visualizations = useSelector(visualizationSelector.selectAll);

    const onAddImages = (images: File[]) => {
        const formData = new FormData();
        images.forEach((image: File, index) => {
            formData.append(`image${index}`, image);
        });

        dispatch(uploadVisualization(formData));
    };

    const onImageChange = useUploadImage(onAddImages);

    return { visualizations, onImageChange };
};
